<template>
    <v-select
        dense
        outlined
        hide-details="auto"
        style="width: 160px"
        :items="socialmediaTypes"
        :placeholder="$t('typ')"
        item-text="text"
        item-value="value"
        v-bind="$attrs"
        v-on="$listeners"
    />
</template>

<script>
export default {
    name: 'SocialmediaSelect',
    data() {
        return {
            socialmediaTypes: [
                { value: 'facebook', text: 'Facebook' },
                { value: 'instagram', text: 'Instagram' },
                { value: 'youtube', text: 'Youtube' },
                { value: 'tiktok', text: 'TikTok' },
                { value: 'linkedin', text: 'LinkedIn' },
                { value: 'twitter', text: 'Twitter/X' },
            ],
        };
    },
};
</script>
